const MIN_SCALE_FACTOR = 1;
const MAX_SCALE = 4;
const ZOOM_STEP = 1.25;
const WHEEL_SENSITIVITY = 0.0015;

function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

function initFasadPlanZoom(root) {
    const viewport = root.querySelector('[data-fasad-viewport]');
    const stage = root.querySelector('[data-fasad-zoom-stage]');
    const plan = root.querySelector('.fasad-plan');
    if (!viewport || !stage || !plan) {
        return;
    }

    let scale = 1;
    let minScale = 1;
    let tx = 0;
    let ty = 0;
    let dragging = false;
    let moved = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startTx = 0;
    let startTy = 0;

    function applyTransform() {
        stage.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
        viewport.classList.toggle('is-zoomed', scale > minScale + 0.01);
    }

    function measure() {
        const vw = viewport.clientWidth;
        const vh = viewport.clientHeight;
        const planW = plan.offsetWidth || vw;
        const planH = plan.offsetHeight || Math.round(planW * 0.5);
        if (planW < 1 || planH < 1 || vw < 1 || vh < 1) {
            return null;
        }
        return { vw, vh, planW, planH };
    }

    function fit(center = true) {
        const m = measure();
        if (!m) {
            return;
        }
        minScale = Math.min(1, m.vw / m.planW, m.vh / m.planH);
        scale = minScale;
        if (center) {
            tx = (m.vw - m.planW * scale) / 2;
            ty = (m.vh - m.planH * scale) / 2;
        }
        applyTransform();
    }

    function clampPan() {
        const m = measure();
        if (!m) {
            return;
        }
        const scaledW = m.planW * scale;
        const scaledH = m.planH * scale;

        if (scaledW <= m.vw) {
            tx = (m.vw - scaledW) / 2;
        } else {
            tx = clamp(tx, m.vw - scaledW, 0);
        }

        if (scaledH <= m.vh) {
            ty = (m.vh - scaledH) / 2;
        } else {
            ty = clamp(ty, m.vh - scaledH, 0);
        }
    }

    function zoomAt(clientX, clientY, nextScale) {
        const m = measure();
        if (!m) {
            return;
        }
        const rect = viewport.getBoundingClientRect();
        const x = clientX - rect.left;
        const y = clientY - rect.top;
        const worldX = (x - tx) / scale;
        const worldY = (y - ty) / scale;
        scale = clamp(nextScale, minScale * MIN_SCALE_FACTOR, MAX_SCALE);
        tx = x - worldX * scale;
        ty = y - worldY * scale;
        clampPan();
        applyTransform();
    }

    function zoomByFactor(factor, clientX, clientY) {
        const rect = viewport.getBoundingClientRect();
        const cx = clientX != null ? clientX : rect.left + rect.width / 2;
        const cy = clientY != null ? clientY : rect.top + rect.height / 2;
        zoomAt(cx, cy, scale * factor);
    }

    root.querySelectorAll('[data-fasad-zoom]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const action = btn.getAttribute('data-fasad-zoom');
            if (action === 'in') {
                zoomByFactor(ZOOM_STEP);
            } else if (action === 'out') {
                zoomByFactor(1 / ZOOM_STEP);
            } else if (action === 'reset') {
                fit(true);
            }
        });
    });

    viewport.addEventListener('wheel', (e) => {
        e.preventDefault();
        const delta = -e.deltaY;
        const factor = Math.exp(delta * WHEEL_SENSITIVITY);
        zoomAt(e.clientX, e.clientY, scale * factor);
    }, { passive: false });

    viewport.addEventListener('pointerdown', (e) => {
        if (e.button !== 0) {
            return;
        }
        if (e.target.closest('[data-fasad-zoom-controls]')) {
            return;
        }
        dragging = true;
        moved = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        startTx = tx;
        startTy = ty;
        viewport.classList.add('is-panning');
        try {
            viewport.setPointerCapture(pointerId);
        } catch (err) {
            // ignore
        }
    });

    viewport.addEventListener('pointermove', (e) => {
        if (!dragging || e.pointerId !== pointerId) {
            return;
        }
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
            moved = true;
        }
        tx = startTx + dx;
        ty = startTy + dy;
        clampPan();
        applyTransform();
    });

    function endPan(e) {
        if (!dragging || (e && e.pointerId !== pointerId)) {
            return;
        }
        dragging = false;
        pointerId = null;
        viewport.classList.remove('is-panning');
    }

    viewport.addEventListener('pointerup', endPan);
    viewport.addEventListener('pointercancel', endPan);
    viewport.addEventListener('lostpointercapture', endPan);

    // После drag не переходить по ссылке квартиры
    viewport.addEventListener('click', (e) => {
        if (!moved) {
            return;
        }
        const link = e.target.closest('a.fasad-zone-link');
        if (link) {
            e.preventDefault();
            e.stopPropagation();
        }
        moved = false;
    }, true);

    let resizeTimer = null;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            const ratio = scale / minScale;
            fit(false);
            if (ratio > 1.01) {
                scale = clamp(minScale * ratio, minScale, MAX_SCALE);
                clampPan();
                applyTransform();
            } else {
                fit(true);
            }
        }, 120);
    });

    // Дождаться layout (картинка/шрифты)
    requestAnimationFrame(() => {
        fit(true);
        requestAnimationFrame(() => fit(true));
    });
}

function initAllFasadPlanZooms() {
    document.querySelectorAll('[data-fasad-plan]').forEach(initFasadPlanZoom);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFasadPlanZooms);
} else {
    initAllFasadPlanZooms();
}

export { initAllFasadPlanZooms };